import { jsx as _jsx } from "react/jsx-runtime";
import { ClipThumbnail } from "~/components/Shared/ClipList/ClipItem/ClipThumbail";
import { DRAG_PREVIEW_HEIGHT, DRAG_PREVIEW_WIDTH } from "~/constants/dnd";
import { ClipIconSize } from "~/types/clip-icon-size";
export const DNDAssetGalleryCardDragPreview = (param)=>{
    let { asset } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: "relative flex flex-1",
        children: /*#__PURE__*/ _jsx(ClipThumbnail, {
            ...asset,
            width: DRAG_PREVIEW_WIDTH,
            height: DRAG_PREVIEW_HEIGHT,
            src: asset.assets.image,
            iconSize: ClipIconSize.large,
            size: "medium",
            borderRadius: 4,
            thumbnailPreference: "default"
        })
    });
};
